export const formatPrice = (price: number): string => {
    return `${new Intl.NumberFormat('ru-RU').format(price)} ₽`;
};

export const isExternalLink = (url: string): boolean => {
    const tmp = document.createElement('a');
    tmp.href = url;
    return tmp.host !== window.location.host;
};
